/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LeadsCreated/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LeadsCreated({
  children,
  viewPath = "/App/Account/Content/Marketing/ReportTable/Content/Content/Content/Pie/CampaignOverview/Breakdown/LeadsCreated"
  
}) {
let marketingAnalyticsTotalCreatedAggregateCountValueData = fromData.useDataValue({ viewPath,
context: 'marketing_analytics',
path: 'total_created.aggregate.count',
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="LeadsCreated.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="LeadsCreated.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color="rgba(247,130,112,0.8)"
 size="large"
 marginRight={2}
 data="marketing_analytics.total_created.aggregate.count"
 text={marketingAnalyticsTotalCreatedAggregateCountValueData}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral600}
 text="Leads - Created"
/>
</div>
{children}
</React.Fragment>)
}